/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import { logTelemetry } from "../../services/telemetry/telemetryWrapper";
import { ActionType, EventName } from "@microsoftit/telemetry-extensions-npm";
import {
  TelemetryHistoryLogs,
  TelemetryLogs,
  TelemetrySubFeature,
} from "../constants";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const triggerReferenceHistory = (eventFrom: string) => {
  const historyRenderEvent = new CustomEvent(eventFrom, {
    detail: true,
  });

  switch (eventFrom) {
    case TelemetryHistoryLogs.DeclineReference:
      logTelemetry(
        TelemetryLogs.PageViews,
        TelemetrySubFeature.HistorySection,
        ActionType.User,
        TelemetryHistoryLogs.DeclineReference + ": using decline button",
        EventName.ButtonClick
      );
      break;
    case TelemetryHistoryLogs.UploadReference:
      logTelemetry(
        TelemetryLogs.PageViews,
        TelemetrySubFeature.HistorySection,
        ActionType.User,
        TelemetryHistoryLogs.UploadReference + ": using upload button",
        EventName.ButtonClick
      );
      break;
    case TelemetryHistoryLogs.ServerErrorReference:
      logTelemetry(
        TelemetryLogs.PageViews,
        TelemetrySubFeature.HistorySection,
        ActionType.User,
        TelemetryHistoryLogs.ServerErrorReference + ": using try again button",
        EventName.ButtonClick
      );
      break;
    case TelemetryHistoryLogs.ReferenceHistoryError:
      logTelemetry(
        TelemetryLogs.PageViews,
        TelemetrySubFeature.HistorySection,
        ActionType.User,
        TelemetryHistoryLogs.ReferenceHistoryError + ": using refresh button",
        EventName.ButtonClick
      );
      break;
  }
  setTimeout(() => {
    window.dispatchEvent(historyRenderEvent);
  }, 500);
};
